import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@shared/lib/utils';

const gridCols = {
  '1': 'grid-cols-1',
  '2': 'grid-cols-2',
  '3': 'grid-cols-3',
  '4': 'grid-cols-4',
  '6': 'grid-cols-6',
  '12': 'grid-cols-12',
} as const;

const gridGaps = {
  none: 'gap-0',
  xs: 'gap-1',
  sm: 'gap-2',
  md: 'gap-4',
  lg: 'gap-6',
  xl: 'gap-8',
} as const;

const gridVariants = cva('grid', {
  variants: {
    cols: gridCols,
    gap: gridGaps,
  },
  defaultVariants: {
    cols: '1',
    gap: 'md',
  },
});

type GridCols = 1 | 2 | 3 | 4 | 6 | 12;

type GridColsKey = keyof typeof gridCols;

type GridGap = keyof typeof gridGaps;

export interface GridProps extends React.HTMLAttributes<HTMLDivElement> {
  cols?: GridCols;
  gap?: GridGap;
}

const Grid = React.forwardRef<HTMLDivElement, GridProps>(
  ({ className, cols, gap, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        gridVariants({
          cols: cols ? (String(cols) as GridColsKey) : undefined,
          gap,
        }),
        className
      )}
      {...props}
    />
  )
);
Grid.displayName = 'Grid';

export { Grid };
